<template>
    <header class="border-b">
        <nuxt-link
            v-if="!isLightbox"
            class="text-button flex h-10 items-center justify-center bg-primary-500 py-2 text-lg font-medium uppercase hover:underline"
            :to="organization.topBarLink"
        >
            {{ organization.topBarText }}
        </nuxt-link>

        <div
            class="relative flex flex-col justify-center overflow-hidden bg-white"
        >
            <div>
                <div
                    class="relative mx-0 flex items-center justify-center gap-4 px-4 py-6 md:px-7 lg:static lg:px-16 lg:py-6"
                >
                    <div class="flex items-center gap-2">
                        <img
                            :src="organization.logo"
                            :alt="organization.longName"
                            class="max-h-12"
                        />
                    </div>
                </div>
            </div>
        </div>
    </header>

    <div class="flex flex-1 flex-col">
        <div
            class="z-2 mx-0 my-2 flex-1 px-4 py-4 md:mx-6 md:my-6 lg:mx-8 lg:px-8"
        >
            <div class="mx-auto flex max-w-screen-xl items-start gap-8">
                <div class="w-full text-center text-xl">Your cart is empty</div>
            </div>
        </div>

        <powered-by-footer />
    </div>
</template>

<script setup lang="ts">
import { definePageMeta, useLayoutMode } from '#imports'
import { useQuery } from '@tanstack/vue-query'
import { graphql } from '~/resources/graphql'
import { computed } from 'vue'
import NuxtLink from '#app/components/nuxt-link'
import { useHead } from 'unhead'
import PoweredByFooter from '~/components/PoweredByFooter.vue'
import { useRpQuery } from '~/composables/graphql'
import { provideViewer } from '~/composables/use-login'

definePageMeta({
    layout: false
})

const query = useRpQuery({ orgLevel: true })
// TODO: when there are more than 100 facilities
// TODO: Limit to active facilities
const { data, suspense } = useQuery({
    queryKey: ['EmptyCartQuery'],
    queryFn: () =>
        query(
            graphql(/* GraphQL */ `
                query EmptyCartQuery {
                    organization {
                        code
                        shortName
                        longName
                        logo
                        topBarLink
                        topBarText
                    }
                }
            `)
        )
})

const organization = computed(() => data.value?.organization)

await Promise.all([suspense(), provideViewer()])

useHead({
    title: organization.value?.longName
})

const { isLightbox } = useLayoutMode()
</script>
